import { AddIcon, EmptyDocument2 } from "asset/icons";
import { invoiceTabType } from "constants/global";
import React from "react";
import { Link } from "react-router-dom";
import emptyInvoiceImg from "asset/images/emptyinvoice.svg";

export const EmptyDocument = ({text }) => {
    return (
        <div className="w-full min-h-[20vh] grid place-items-center text-center">
            <EmptyDocument2 />

            {text ? (
                <h4 className="text-gray-40 font-semibold text-sm my-2.5">
                    {text}
                </h4>
            ) : (
                <h4 className="text-gray-40 font-semibold text-sm my-2.5">
                    You haven’t uploaded <br /> any documents
                </h4>
            )}
        </div>
    );
}

const InvoiceEmptyState = ({
    searchQuery,
    activeTab,
    link = "/invoice/create-invoice",
    linkText = "Create invoice",
    forFinance = false,
}) => {
    return (
        <div className={`my-[70px] grid place-items-center text-center`}>
            <img src={emptyInvoiceImg} alt="Empty icon" />
            <h4 className="text-main-dark font-bold text-xl leading-[24.3px] my-2.5">
                {searchQuery?.length ? (
                    forFinance ? (
                        <span className="text-center">
                            No matching credit history. We couldn’t find any credit <br />
                            that matches your filter or search.
                        </span>
                    ) : (
                        <span>
                            No matching invoice. We couldn’t find any invoice <br />
                            that matches your filter or search.
                        </span>
                    )
                ) : forFinance ? (
                    "You have not created any credit yet"
                ) : activeTab === invoiceTabType[0] ? (
                    "You have not created any invoices yet"
                ) : (
                    "You don't have an incoming invoice yet"
                )}
            </h4>

            <p className="text-main-grey text-sm leading-[19.6px] font-normal">
                Create and manage your invoices here.
            </p>
            <div className="mt-4">
                <Link
                    to={link}
                    className={`hover:opacity-90 bg-[#6F00FF] mt-0 sm:!mt-0 flex items-center gap-2 text-white rounded-lg py-[10px] px-3 md:!px-5 text-sm`}
                >
                    <AddIcon className=" stroke-white fill-white size-4" />
                    <span>{linkText}</span>
                </Link>
            </div>
        </div>
    );
};

export default InvoiceEmptyState;
